(() => {
  if (customElements.get('hondo-coming-soon')) return;
  class HondoComingSoon extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.scope = this.closest('[data-section-type="product"]') || this.form;
      this.variants = JSON.parse(this.querySelector('[data-hondo-coming-soon-variants]').textContent);
      this.message = this.querySelector('.hondo-coming-soon-message');
      this.queueSync = () => {
        if (this.pending) return;
        this.pending = true;
        queueMicrotask(() => {
          this.pending = false;
          if (this.isConnected) this.sync();
        });
      };
      this.scope.addEventListener('change', this.queueSync, true);
      this.sync();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.queueSync, true);
    }
    sync() {
      const id = this.form.querySelector('[data-variant-select]')?.value;
      const options = Array.from(this.scope.querySelectorAll('.product__variants-wrapper select[name^="options["]')).map(input => input.value);
      const variant = options.length
        ? this.variants.find(item => item.options.every((value, index) => value === options[index]))
        : this.variants.find(item => String(item.id) === id);
      const comingSoon = Boolean(variant?.comingSoon);
      this.message.hidden = !comingSoon;
      this.scope.toggleAttribute('data-hondo-coming-soon', comingSoon);
      this.form.querySelectorAll('[data-add-to-cart]').forEach(button => {
        const text = button.querySelector('[data-add-to-cart-text]');
        if (comingSoon && !variant.available) text.textContent = this.dataset.label;
        else if (variant) text.textContent = variant.available ? button.dataset.langAvailable : button.dataset.langSoldOut;
        button.setAttribute('aria-label', text.textContent.trim());
        button.setAttribute('aria-disabled', String(button.disabled));
      });
    }
  }
  customElements.define('hondo-coming-soon', HondoComingSoon);
  class HondoComingSoonBadge extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.product-item');
      this.ids = new Set(this.dataset.variantIds.trim().split(/\s+/));
      this.sync = () => {
        const variantId = this.card?.dataset.variantId;
        this.hidden = Boolean(variantId && !this.ids.has(variantId));
        const badge = this.querySelector('.product-badge--coming-soon');
        const label = variantId ? this.dataset.label : this.dataset.summary;
        if (badge.textContent !== label) badge.textContent = label;
      };
      if (this.card) {
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.card, { attributes: true, attributeFilter: ['data-variant-id'] });
      }
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }
  customElements.define('hondo-coming-soon-badge', HondoComingSoonBadge);
})();
